<script setup lang="ts">
import PhosphorIcon from "@/components/UI/PhosphorIcon.vue";

/**
 * Le champ texte du panneau de l'outil texte : affiche le texte du PROCHAIN
 * placement, un appui ouvre la saisie. Le texte se pose ensuite en glissant
 * le stylet sur le plan (TextDragger).
 */
defineProps<{
  message: string;
  /** L'outil texte lui-même est actif (et non l'écriture manuscrite) */
  active: boolean;
}>();

const emit = defineEmits<{
  open: [];
  clear: [];
}>();
</script>

<template>
  <div
    role="button"
    class="text-tool-field"
    :class="{
      'text-tool-field-active': active,
      'text-tool-field-muted': !active,
    }"
    @click="emit('open')"
  >
    <div class="text-tool-lead">
      <PhosphorIcon name="keyboard" :size="18" />
    </div>
    <!-- Pendant l'écriture manuscrite, ce champ ramène au mode texte -->
    <div v-if="!active" class="text-tool-value text-tool-placeholder">
      {{ $t("canvas:tools.handwriting.backToTextHint") }}
    </div>
    <div v-else-if="message.length" class="text-tool-value">
      {{ message }}
    </div>
    <div v-else class="text-tool-value text-tool-placeholder">
      {{ $t("canvas:tools.text.input.placeholder") }}
    </div>
    <!-- Effacer, sans ouvrir la saisie -->
    <button
      v-if="message.length && active"
      class="text-tool-end"
      type="button"
      @click.stop.prevent="emit('clear')"
    >
      <PhosphorIcon name="x" :size="15" />
    </button>
  </div>
</template>
